// extracted by mini-css-extract-plugin
export default {"pageNotFound":"_404_pageNotFound__YVS6Z","head":"_404_head__3JybL"};